import type { ChatMessage } from '@teo/widget-shared';
import { resolveMessageMedia } from '@teo/widget-shared';

export function getMessageBubbleLayout(message: ChatMessage): {
  bubbleClass: string;
} {
  const { attachment, linkPreviews, caption } = resolveMessageMedia(message);
  const hasAttachment = Boolean(attachment);
  const hasLinkPreviews = linkPreviews.length > 0;
  const hasCaption = Boolean(caption?.trim());

  let bubbleClass = 'teo-bubble';

  if (hasAttachment && !hasCaption && !hasLinkPreviews) {
    bubbleClass += ' teo-bubble--media';
  } else if (hasLinkPreviews || (hasAttachment && (hasCaption || hasLinkPreviews))) {
    bubbleClass += ' teo-bubble--rich';
  }

  return { bubbleClass };
}

/** @deprecated Use `getMessageBubbleLayout`. */
export const getIncomingBubbleLayout = getMessageBubbleLayout;
